interface QuickSummaryProps {
  points: string[];
}

/** "Resumo em 30 segundos" — 3 a 5 pontos objetivos no topo do artigo. */
export const QuickSummary: React.FC<QuickSummaryProps> = ({ points }) => {
  if (!points || points.length === 0) return null;

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-6 mb-6">
      <div className="flex items-center gap-2 mb-3">
        <span className="text-lg">⏱️</span>
        <span className="text-blue-800 font-bold text-sm uppercase tracking-wider">
          Resumo em 30 segundos
        </span>
      </div>
      <ul className="space-y-2">
        {points.map((point, index) => (
          <li key={index} className="flex items-start gap-2 text-gray-800 leading-relaxed">
            <span className="flex-shrink-0 mt-1.5 w-1.5 h-1.5 rounded-full bg-blue-500" aria-hidden />
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
